export default "__VITE_ASSET__44d95d28__"